import { useNavigate } from 'react-router-dom'
import React, { useEffect, useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { PaytrieAPI } from '@paytrie/client'

import { Button } from '@/components/Button/Button'
import { LeftAlignSmallText } from '@/components/widget-components'
import {
  trackOnboardingStepCompleted,
  trackOnboardingStepViewed,
} from '@/utils/analytics'

export default function FraudWarningFollowUp() {
  const { t } = useTranslation()
  const navigate = useNavigate()

  useEffect(() => {
    trackOnboardingStepViewed('fraud_warning')
  }, [])

  const handleContinue = useCallback(
    (e?: React.FormEvent<HTMLFormElement>) => {
      if (e) e.preventDefault()
      void PaytrieAPI.updateCurrentUser({
        currentFlow:
          PaytrieAPI.UpdateCurrentUserBodyCurrentFlow.FRAUD_WARNING_FOLLOW_UP,
      }).catch(() => {})
      trackOnboardingStepCompleted('fraud_warning')
      navigate('/SignupKYC')
    },
    [navigate]
  )
  useEffect(() => {
    const handleKeyPress = (e: KeyboardEvent) => {
      if (e.key === 'Enter') {
        handleContinue()
      }
    }
    document.addEventListener('keydown', handleKeyPress)
    return () => {
      document.removeEventListener('keydown', handleKeyPress)
    }
  }, [handleContinue])

  return (
    <form
      onSubmit={handleContinue}
      className="flex flex-col gap-5"
      data-testid="container-fraud-warning-follow-up"
    >
      <div className="text-lg font-semibold uppercase">
        {t('fraudWarningFollowUp.title')}
      </div>
      <div className="text-base">{t('fraudWarningFollowUp.subtitle')}</div>

      <LeftAlignSmallText
        className="mt-1 sm:mt-1 md:mt-4 lg:mt-6"
        style={{ paddingBottom: '1em' }}
        data-testid="text-warning-content"
      >
        <p data-testid="text-warning-main">
          {t('fraudWarningFollowUp.warningText')}
        </p>
      </LeftAlignSmallText>

      <div className="mb-4">
        <LeftAlignSmallText style={{ paddingBottom: '0em' }}>
          <p className="font-semibold" data-testid="text-acknowledgment">
            {t('fraudWarningFollowUp.acknowledgment')}
          </p>
        </LeftAlignSmallText>
      </div>

      <Button
        type="submit"
        className="inline-flex items-center py-4 px-4 w-full justify-center lg:gap-2"
        data-testid="btn-continue-fraud-warning"
      >
        {t('fraudWarningFollowUp.submit')}
      </Button>
    </form>
  )
}
